<template>
  <el-dialog
    :title="`补打`"
    :visible.sync="show"
    width="540">
    <div class="d-flex center">
      <div class="d-flex mr20">
        <label class="mr10">补打人:</label>
        <el-select
          class="input200"
          filterable
          remote
          :remote-method="getUserOpts"
          @focus="getUserOpts('')"
          v-model="printUser"
        >
          <el-option
            v-for="item in userOpts"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="d-flex">
        <label class="mr10">次数:</label>
        <el-input-number
          class="input200"
          v-model="count"
          :min="1"
        ></el-input-number>
      </div>
    </div>
    <div
      slot="footer"
      class="d-flex right"
    >
      <el-button
        type="primary"
        size="small"
        @click="confirm"
      >确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  userOptions
} from '@/api.js'
export default {
  name: 'Frame',
  data() {
    return {
      show: false,
      count: 1,
      printUser: undefined,
      userOpts: []
    }
  },
  methods: {
    open() {
      this.count = 1
      this.printUser = undefined
      this.show = true
    },
    confirm() {
      const data = {
        count: this.count,
        printUser: this.printUser
      }

      this.$emit('confirm', data)
      this.close()
    },
    getUserOpts(name) {
      const url = userOptions.replace('{type}', 0)
      return this.$request('get', url, { name } ).then((res) => {
        this.userOpts = res
      })
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style scope lang="scss"></style>